import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
  MatAutocompleteModule,
  MatAutocompleteSelectedEvent
} from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule
} from '@angular/material/dialog';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { debounceTime, filter, switchMap } from 'rxjs';
import { NewCustomerDialogComponent } from '../dialogs/new-customer-dialog/new-customer-dialog.component';
import { CustomerNamePipe } from '../pipes/customer-name.pipe';
import { CustomerService } from '../services/customer.service';

@Component({
  selector: 'app-update-customer-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    MatFormField,
    MatAutocompleteModule,
    MatInput,
    MatOption,
    MatButtonModule,
    CustomerNamePipe,
    AsyncPipe
  ],
  templateUrl: './update-customer-dialog.component.html',
  providers: [CustomerService]
})
export class UpdateCustomerDialogComponent {
  CREATE_NEW_CUSTOMER = {};
  searchControl = new FormControl('');
  selectedCustomer = null;
  customerService = inject(CustomerService);
  dialog = inject(MatDialog);
  displayFn = () => '';
  destroyRef = inject(DestroyRef);
  data = inject(MAT_DIALOG_DATA);

  filteredCustomers$ = this.searchControl.valueChanges.pipe(
    debounceTime(300),
    filter(Boolean),
    switchMap((searchText) => this.customerService.search(searchText))
  );

  optionSelectedEvent(event: MatAutocompleteSelectedEvent) {
    if (event.option.value === this.CREATE_NEW_CUSTOMER) {
      this.dialog
        .open(NewCustomerDialogComponent)
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef), filter(Boolean))
        .subscribe((newCustomer) => {
          this.selectedCustomer = newCustomer;
        });
      return;
    }
    this.selectedCustomer = event.option.value;
  }
}
